export enum ConsultantContractGeneratorType {
  SelfInvoicingTemplateDataGenerator = "SelfInvoicingTemplateDataGenerator",
  FrameworkNationalTemplateDataGenerator = "FrameworkNationalTemplateDataGenerator",
  OutsourceNationalTemplateDataGenerator = "OutsourceNationalTemplateDataGenerator",
  EmploymentNationalTemplateDataGenerator = "EmploymentNationalTemplateDataGenerator",
  IntermittentNationalTemplateDataGenerator = "IntermittentNationalTemplateDataGenerator"
}
